// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.6.286",
  "gitHash": "95cf265039345f1abaf50864f5a02e91d868b40c",
  "versionWithHash": "5.6.286-95cf265039345f1abaf50864f5a02e91d868b40c"
};
